module.exports = {
  title: '404 Page',
  context: {
    masthead: '@masthead',
    hero: {
      type: 'text-only',
      heading: {
        text: 'Page not found',
        tag: 'h1',
        class: 'heading-1'
      }
    },
    mainContent: {
      text: '<p>Please return to the <a href="/">homepage</a> or try searching again.</p>'
    },
    footer: '@footer'
  }
}
